<template>
    <section id="forgotPassword">
      <div style="height: 55px;background-color: #fff;margin-bottom: 110px;"></div>
      <div class="main" v-if="isShow">
        <p class="title">输入账号</p>
        <div class="verify-line"></div>
        <div class="caption">输入找回密码的手机号码</div>
        <div class="delete_input">
          <input type="number" class="enter_account" placeholder="请输入手机号码" v-model="userPhone">
        </div>
        <!--按钮样式-->
        <div class="next">
          <button type="button" :class="(userPhone==='')? 'opacity1' : 'opacity2'" @click="check">下一步</button>
          <div style="height: 60px;"></div>
        </div>
      </div>
      <!--验证身份-->
      <div class="main" v-if="isHidden">
        <p class="title">验证身份</p>
        <div class="verify-line"></div>
        <div class="random">
          <div class="text">
            <span>已发送验证码至&nbsp;&nbsp;</span>
            <span>{{userInfo.userPhone | getPhone}}</span>
          </div>
          <div class="box">
            <input class="randCode" v-model="randCode" type="number" placeholder="手机验证码">
            <div class="sendBtn" @click="getCode()">{{msg}}</div>
          </div>
          <div class="next">
            <button type="button" :class="(randCode === '') ? 'opacity1' : 'opacity2'" @click="compare()">验证</button>
            <div style="height: 60px;"></div>
          </div>
        </div>
      </div>
      <!--设置密码-->
      <div class="main" v-if="setNew">
        <p class="title">设置密码</p>
        <div class="pwd_tips">
          密码长度6-16位，支持字母、数字、符号
        </div>
        <div class="verify-line"></div>
        <div class="delete_input">
          <input type="password" class="enter_account" placeholder="请输入密码" v-model="newPassWord">
        </div>
        <div class="delete_input password-margin">
          <input type="password" class="enter_account" placeholder="请再次输入" v-model="againPassWord">
          <p style="text-align: left;font-size: 14px;color: red;line-height: 15px;">{{text}}</p>
        </div>
        <div class="next">
          <button type="button" :class="(againPassWord==='')? 'opacity1' : 'opacity2'" @click="save">保存</button>
          <div style="height: 60px;"></div>
        </div>
      </div>
      <!--遮罩弹框-->
      <div class="mask" v-if="toast">
        <div class="toast">
          <h4>已成功设置密码</h4>
            <div class="login_button" @click="toLogin">好</div>
        </div>
      </div>
      <!--备案信息-->
      <div class="loginFoot">
        <div>广州市中渠传媒广告有限公司 版权所有</div>
        <div><a href="https://beian.miit.gov.cn">粤ICP备12059610号-3</a></div>
        <div>
          <img class="beiAn" :src="beiAn"/>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011102001129" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44011102001129号</p></a>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: 'forgotPassword',
  data () {
    return {
      userPhone: '',
      randCode: '',
      randId: '',
      newPassWord: '',
      againPassWord: '',
      text: '',
      userInfo: {},
      time: 0,
      msg: '获取验证码',
      randType: 'BBS_PASS',
      isShow: true,
      isHidden: false,
      setNew: false,
      toast: false,
      beiAn: require('../../assets/image/beian.png')
    }
  },
  methods: {
    check () {
      let that = this
      that.axios.post('/userInfo', {
        userPhone: that.userPhone
      }, {
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          var res = response.data.value
          that.userInfo = res
          that.getCode()
          that.isShow = false
          that.isHidden = true
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    // 验证验证码
    compare () {
      let that = this
      that.axios.post('/common/checkRand', {
        userPhone: that.userPhone,
        randCode: that.randCode,
        randType: that.randType
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          that.randId = response.data.value
          that.isHidden = false
          that.setNew = true
          that.randCode = ''
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    save () {
      if (this.newPassWord !== this.againPassWord) {
        this.text = '两次密码输入不一致，请重新输入'
        return
      }
      let that = this
      that.axios.post('/changePassWord', {
        userId: that.userInfo.userId,
        newPassWord: that.newPassWord,
        randId: that.randId
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          console.log(response.data.value)
          that.toast = true
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    toLogin () {
      this.setNew = false
      this.toast = false
      this.$router.replace('/login')
    },
    // 发送倒计时
    'startTime': function () {
      let that = this
      that.time = 60
      window.time = setInterval(function () {
        that.msg = that.time + 'S'
        that.time--
        if (that.time <= 0) that.closeTime()
      }, 1000)
    },
    // 倒计时结束关闭
    'closeTime': function () {
      clearInterval(window.time)
      this.msg = '重新发送'
    },
    // 获取随机数
    'getRandomCode': function () {
      let that = this
      return new Promise(function (resolve, reject) {
        that.axios.post('../api/wx/sms', {
          userPhone: that.userPhone
        }, {
          emulateJSON: true
        }).then(function (response) {
          if (response.data.status === 0) {
            resolve(response.data.value)
          } else {
            reject(response.data.msg)
          }
        }).catch(function (response) {
          console.log(response)
          that.$store.commit('setToastMsg', '网络错误')
        })
      })
    },
    // 获取验证码
    'getCode': function () {
      if (this.userPhone === '') {
        this.$store.commit('setToastMsg', '手机号不能为空')
        return
      }
      if (this.time > 0) return
      let that = this
      that.msg = '发送中...'
      that.getRandomCode().then(function (res) {
        that.axios.post('../api/wx/getRand', {
          userPhone: that.userPhone,
          randType: that.randType,
          randomCode: res[0] + res[4] + res[8] + res[12]
        }, {
          emulateJSON: true
        }).then(function (response) {
          if (response.data.status === 0) {
            that.startTime()
          } else {
            that.$store.commit('setToastMsg', response.data.msg)
            that.msg = '重新发送'
          }
        }, function (response) {
          console.log(response)
          that.$store.commit('setToastMsg', '网络错误')
          that.msg = '重新发送'
        })
      }, function (err) {
        that.$store.commit('setToastMsg', err)
        that.msg = '重新发送'
      })
    }
  },
  filters: {
    getPhone (num) {
      if (num) {
        return num.slice(0, 3) + '******' + num.slice(9)
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>
  *{
    font-family: 'Microsoft YaHei' !important;
  }
  body{
    width: 100%;
    height: 100%;
  }
  #forgotPassword{
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    background-color: #F0F0F0;
  }
  .mb30{
    margin-bottom: 30px;
  }
  .main{
    width: 680px;
    margin: 0 auto;
    background-color: #fff;
    border: 1px solid #e5e5e5;
  }
  .main .title{
    font-size: 20px;
    padding: 40px;
    text-align: center;
    font-weight: bold;
    color: #333;
  }
  .verify-line{
    width: 680px;
    height: 1px;
    margin: 0 auto 30px;
    background-color: #e6e6e6;
  }
  .caption{
    width: 320px;
    margin: 0 auto 20px;
    font-size: 16px;
    text-align: center;
  }
  .delete_input {
    width: 322px;
    margin: 0 auto 30px;
  }
  .enter_account {
    width: 320px;
    height: 45px;
    line-height: 45px;
    border-radius: 3px;
    font-size: 14px;
    border: 1px solid #e5e5e5;
    outline: none;
    text-indent: 20px;
  }
  input:focus{
    border: 1px solid #999;
  }
  .next button{
    width: 320px;
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    background-color: #05B570;
    border-radius: 3px;
    color: #feffff;
    border: none;
    outline: none;
    cursor: pointer;
    margin: 0 auto;
  }
  .opacity1{
    opacity: 0.5;
  }
  .opacity2{
    opacity: 1;
  }
  .loginFoot {
    font-size: 12px;
    width: 600px;
    margin: 100px auto;
    padding-bottom: 20px;
    color: #999;
  }
  .loginFoot div {
    float: left;
    padding: 0 10px;
  }
  .beiAn{
    vertical-align: top;
  }
  .text{
    width: 320px;
    margin: 0 auto;
  }
  .text>span{
    text-align: center;
    color: #05B570;
  }
  .box{
    width: 320px;
    height: 45px;
    margin: 20px auto 30px;
    position: relative;
  }
  input.randCode{
    width: 220px;
    height: 43px;
    line-height: 45px;
    border-radius: 3px;
    float: left;
    font-size: 14px;
    border: 1px solid #e5e5e5;
    outline: none;
    text-indent: 20px;
  }
  .sendBtn{
    margin: 0;
    padding: 0;
    width: 90px;
    height: 43px;
    line-height: 43px;
    font-size: 14px;
    float: right;
    border: 1px solid #c5ebde;
    border-radius: 3px;
    color: #05B570;
    background-color: #ffffff;
    /*outline: none;*/
    cursor: pointer;
    text-align: center;
  }
  /*--------------设置密码----------*/
  .pwd_tips{
    padding-bottom: 30px;
    text-align: center;
  }
  .password-margin{
    margin: 20px auto 30px;
  }
  /*遮罩*/
  .mask{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,.1);
  }
  .toast {
    z-index: 9999;
    background: #FFFFFF;
    width: 440px;
    position: absolute;
    border-radius: 5px;
    height: 190px;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    text-align: center;
  }
  h4{
    width: 420px;
    margin:10px auto 30px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #363636;
    font-size: 16px;
  }
  .login_button {
    color: #fff;
    background: #2aad6f;
    display: block;
    text-align: center;
    width: 320px;
    height: 46px;
    line-height: 46px;
    font-size: 16px;
    cursor: pointer;
    margin: 0 auto 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/forgotPassword.vue